import {Chess, DEFAULT_POSITION} from "chess.js";
import {ChessPieces, fenToPiece} from "./chessPieces";

export const calculateTakenPiecesFromFen = (fen, color) => {
    const piecePlacements = fen.split(" ")[0]
    let pieceRegex;
    if(color === "white") {
        pieceRegex = /([A-Z])/g
    } else {
        pieceRegex = /([a-z])/g
    }

    const pieceCounts = new Map()

    pieceCounts.set(ChessPieces.KING, 1);
    pieceCounts.set(ChessPieces.QUEEN, 1);
    pieceCounts.set(ChessPieces.ROOK, 2);
    pieceCounts.set(ChessPieces.BISHOP, 2);
    pieceCounts.set(ChessPieces.KNIGHT, 2);
    pieceCounts.set(ChessPieces.PAWN, 8);


    let match;
    while ((match = pieceRegex.exec(piecePlacements)) !== null) {
        pieceCounts.set(fenToPiece[match[1].toLowerCase()], pieceCounts.get(fenToPiece[match[1].toLowerCase()]) - 1);
    }

    return pieceCounts;
}

// Material balance from white's point of view (positive = white is ahead)
export const materialBalance = (fen) => {
    const values = {p: 1, n: 3, b: 3, r: 5, q: 9, k: 0};
    let balance = 0;
    for (const ch of fen.split(" ")[0]) {
        const lower = ch.toLowerCase();
        if (values[lower] === undefined) continue;
        balance += ch === lower ? -values[lower] : values[lower];
    }
    return balance;
}

const fenColorRegex = /.*? ([wb])/
export const getCurrentTurnFromFen = (fen) => {
    const match = fen.match(fenColorRegex);

    if (!match) {
        throw new Error("Invalid fen provided")
    }

    return match[1];
}

// Replays a list of SAN moves from a start position.
// Returns one entry per position: index 0 is the start position, index i is the position after i moves.
// Each entry is {fen, move, inCheck} where move is the verbose chess.js move that led to the position.
export const buildPositions = (initialFen, sanMoves) => {
    const chess = new Chess(initialFen || DEFAULT_POSITION);
    const positions = [{fen: chess.fen(), move: null, inCheck: chess.inCheck()}];
    for (const san of sanMoves || []) {
        try {
            const move = chess.move(san);
            positions.push({fen: chess.fen(), move, inCheck: chess.inCheck()});
        } catch (e) {
            console.error(`Could not replay move ${san}`, e);
            break;
        }
    }
    return positions;
}

// Finds the square of the king that is in check (for highlighting), or null
export const findCheckedKing = (fen) => {
    try {
        const chess = new Chess(fen);
        if (!chess.inCheck()) return null;
        const turn = chess.turn();
        const board = chess.board();
        for (const row of board) {
            for (const piece of row) {
                if (piece && piece.type === "k" && piece.color === turn) return piece.square;
            }
        }
    } catch (e) {
        return null;
    }
    return null;
}

// Approximate lichess style time categories, based on estimated game duration
export const timeCategory = (baseMinutes, incrementSeconds) => {
    const estimate = Number(baseMinutes) * 60 + Number(incrementSeconds || 0) * 40;
    if (estimate < 180) return "bullet";
    if (estimate < 480) return "blitz";
    if (estimate < 1500) return "rapid";
    return "classic";
}

export const formatTimeControl = (baseMinutes, incrementSeconds) => {
    const base = Number(baseMinutes);
    const baseText = base < 1 ? `${base * 60}s` : `${base}`;
    return `${baseText}+${Number(incrementSeconds || 0)}`;
}

export const formatClock = (ms) => {
    if (ms === undefined || ms === null || Number.isNaN(ms)) return "--:--";
    const clamped = Math.max(0, ms);
    const totalSeconds = Math.floor(clamped / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    if (hours > 0) {
        return `${hours}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    }
    if (clamped < 10000) {
        const tenths = Math.floor((clamped % 1000) / 100);
        return `${minutes}:${String(seconds).padStart(2, "0")}.${tenths}`;
    }
    return `${minutes}:${String(seconds).padStart(2, "0")}`;
}
